<template lang="pug" src="./accessibility.pug"></template>

<script>
import HeroImage from 'components/hero/hero-image/hero-image'

export default {
  computed: {
    props () {
      return this.$store.state.pages['accessibility']
    }
  },
  components: {
    HeroImage
  },
  data () {
    return {
      companyName: 'Defay Orthodontics', // Fill this in
      domain: "<a href='https://defayortho.com'>defayortho.com</a>", // Fill this in
      email: "<a href='mailto:office@defayortho.com'>office@defayortho.com</a>", // Fill this in
      phone: "<a href='tel:+18015460892'>801-546-0892</a>", // Fill this in
      formattedEmail: ''
    }
  },
  mounted () {
    this.formatEmail()
  },
  methods: {
    formatEmail () {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/accessibility/accessibility.vue